import { getUnEditable } from "../../Redux/Reducers/jobInfo";

export function jobStatusCheck(response, dispatch) {
    const unEditableFlag = "PaymentRefundRequest" === response?.jobInfo?.status;
    dispatch(getUnEditable(unEditableFlag));
}